import React, { memo, useState, MouseEvent } from "react";
import { Grid, Typography, CardActions, Button } from "@material-ui/core";
import Popover from "@material-ui/core/Popover";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import useUserProfile from "../../../Hook/useUserProfile";
import UserAvatar from "jb_component_library/components/UserAvatar";

const UserDetail: React.MemoExoticComponent<React.FC<{ logout: () => Promise<void> }>> = memo(
	(props: { logout: () => Promise<void> }) => {
		const [anchorEl, setAnchorEl] = useState<Element | null>(null);
		const handleClose = () => {
			setAnchorEl(null);
		};
		const handleMenu = (event: MouseEvent) => {
			setAnchorEl(event.currentTarget);
		};
		const userProfile = useUserProfile();
		if (userProfile) {
			return (
				<React.Fragment>
					<Button onClick={handleMenu}>
						<UserAvatar
							name={userProfile.displayName}
							size={44}
							fontSize={30}
							fontSizeUnit="px"
							userPhoto={`data:image/png;base64,${userProfile.photo}`}
						></UserAvatar>
					</Button>
					<Popover
						anchorEl={anchorEl}
						open={Boolean(anchorEl)}
						onClose={handleClose}
						anchorOrigin={{
							vertical: "bottom",
							horizontal: "center",
						}}
						transformOrigin={{
							vertical: "top",
							horizontal: "center",
						}}
					>
						<Card>
							<CardContent>
								<Grid container spacing={1} justifyContent="flex-start" alignItems="center">
									<Grid item>
										<UserAvatar
											name={userProfile.displayName}
											size={60}
											fontSize={40}
											fontSizeUnit="px"
											userPhoto={`data:image/png;base64,${userProfile.photo}`}
										></UserAvatar>
									</Grid>
									<Grid item>
										<Typography variant="h6" component="div">
											{userProfile.displayName}
										</Typography>
										<Typography variant="subtitle1" component="div">
											{userProfile.staffId}
										</Typography>
									</Grid>
								</Grid>
							</CardContent>
							<CardActions>
								<Grid container justifyContent="center" alignItems="center">
									<Button variant="contained" color="primary" onClick={props.logout}>
										Sign out
									</Button>
								</Grid>
							</CardActions>
						</Card>
					</Popover>
				</React.Fragment>
			);
		}
		return <div></div>;
	}
);

export default UserDetail;
